<!-- SitesOverview.vue -->
<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import MapComponent from '@/components/MapComponent.vue'
import SiteListVue from '@/components/SiteList.vue'
// import { sitesStatic } from '../composables/SiteList'
import { useSites } from '@/composables/useSites'
import { Vector } from 'ol/source'
import { Feature } from 'ol'
import { Point } from 'ol/geom'
import { Style, Icon } from 'ol/style'
import { Circle as CircleStyle, Fill, Stroke } from 'ol/style'
import { Vector as VectorLayer } from 'ol/layer'
import { fromLonLat } from 'ol/proj'
import type { Extent } from 'ol/extent'
import { useMapStore } from '@/stores/mapStore'

import defaultImgUri from '@/assets/default.png'
import agrImgUri from '@/assets/agr.png'
import magnoxImgUri from '@/assets/magnox.png'
import ndaImgUri from '@/assets/nda.png'
import edfImgUri from '@/assets/edf.png'

import { useRouter } from 'vue-router'
import { useDrawer } from '@/composables/useDrawer'
import { useProjects } from '@/composables/useProjects'
import { useDatasets } from '@/composables/useDatasets'

const icons: { [key: string]: string } = {
  default: defaultImgUri,
  edfImgUri: edfImgUri,
  magnoxImgUri: magnoxImgUri,
  ndaImgUri: ndaImgUri,
  agrImgUri: agrImgUri
}

export default defineComponent({
  components: {
    MapComponent,
    SiteListVue
  },

  
//   const info = document.getElementById('info');

// let currentFeature;
// const displayFeatureInfo = function (pixel, target) {
//   const feature = target.closest('.ol-control')
//     ? undefined
//     : map.forEachFeatureAtPixel(pixel, function (feature) {
//         return feature;
//       });
//   if (feature) {
//     info.style.left = pixel[0] + 'px';
//     info.style.top = pixel[1] + 'px';
//     if (feature !== currentFeature) {
//       info.style.visibility = 'visible';
//       info.innerText = feature.get('ECO_NAME');
//     }
//   } else {
//     info.style.visibility = 'hidden';
//   }
//   currentFeature = feature;
// };

// map.on('pointermove', function (evt) {
//   if (evt.dragging) {
//     info.style.visibility = 'hidden';
//     currentFeature = undefined;
//     return;
//   }
//   displayFeatureInfo(evt.pixel, evt.originalEvent.target);
// });

// map.on('click', function (evt) {
//   displayFeatureInfo(evt.pixel, evt.originalEvent.target);
// });

// map.getTargetElement().addEventListener('pointerleave', function () {
//   currentFeature = undefined;
//   info.style.visibility = 'hidden';
// });
  setup() {
    // Function to modify the site-info box which displays the site name when hovering over a site

    const { sites, fetchItems } = useSites()
    const useProjectsInterface = useProjects()
 

    const router = useRouter()
    onMounted(
      
      async () => {
        const siteInfoBox = document.getElementById('mapInfo')

        const modifySiteInfoBox = (siteName: string) => {
          if (siteInfoBox) {
            siteInfoBox.innerHTML = siteName
          }
        }

        await fetchItems()
        await useProjectsInterface.fetchProjects()

        for (const project of useProjectsInterface.projects.value) {
          console.log('Project:', project)
          // if project priority is 1, then set the site as visible
          if (project.priority === 1) {
            const siteId = project.area_of_interest
            console.log('Site ID:', siteId)
            for (const site of sites.value) {
              if (site.id === siteId) {
                site.visible = true
              }
            }
          }
          // if theres an available psi dataset, set the site as visible
          const siteName = sites.value.find((site) => site.id === project.area_of_interest)?.name
          console.log('Site name:', siteName)
          if (!siteName) {
            console.error('Site name not found')
            continue
          }
          const datasetsInterface = useDatasets(siteName)
          datasetsInterface.fetchDatasets().then(() => {
            if (datasetsInterface.datasets.value.length > 0) {
              for (const site of sites.value) {
                if (site.id === project.area_of_interest) {
                  site.visible = true
                }
              }
            }
          })
        }

        // sort the active sites to the top
        sites.value.sort((a: any, b: any) => {
          if (a.visible && !b.visible) {
            return -1
          }
          if (!a.visible && b.visible) {
            return 1
          }
          return 0
        })

        // sort every half second
        setInterval(() => {
          sites.value.sort((a: any, b: any) => {
            if (a.visible && !b.visible) {
              return -1
            }
            if (!a.visible && b.visible) {
              return 1
            }
            return 0
          })
        }, 500)

        console.log(sites)
        const sitesStatic = sites.value
        console.log(sitesStatic)
        modifySiteInfoBox('None!')
        const mapStore = useMapStore()
        // break if map is not initialized
        if (!mapStore.map) {
          console.error('Map not initialized')
          return
        }

        const generateSiteLayer = () => {
          // Create a vector source and layer
          const vectorSource = new Vector({
            features: sitesStatic.map((sprite: any) => {
              // switch order of sprite.coords
              const lonLat = [sprite.centre_lon as number, sprite.centre_lat as number]
              console.log('lonLat:', lonLat)
              const feature = new Feature({
                geometry: new Point(fromLonLat(lonLat)),
                name: sprite.name
              })
              console.log('sprite:', sprite)
              console.log('iconstr:', sprite.icon as string)
              console.log('icon:', icons[sprite.icon as string])
              if (!sprite.icon) {
                sprite.icon = 'default'
                console.log('nocon')
              }
              feature.setStyle(
                new Style({
                  image: new Icon({
                    src: icons[sprite.icon as string],
                    scale: 0.2
                  })
                })
              )
              return feature
            })
          })

          const vectorLayer = new VectorLayer({
            source: vectorSource
          })

          return vectorLayer
        }

        // Add the vector layer to the map
        const mapContainer = mapStore.map
        const mapContainerView = mapContainer.getView()
        if (!mapContainer || !mapContainerView) {
          console.error('Map container not created or view not initialized')
          return
        }
        const vectorLayer = generateSiteLayer()
        const vectorSource = vectorLayer.getSource()
        if (!vectorLayer || !vectorSource) {
          console.error('Vector layer not created')
          return
        }
        mapContainer.addLayer(vectorLayer)

        // OVERLAY AND INTERACTION
        const hoverThreshold = 100000
        const pixelHoverThreshold: () => number = () => {
          if (!mapContainerView) {
            console.error('Map view not initialized')
            return 1
          }
          const res = mapContainerView.getResolution()
          if (!res) {
            console.error('Resolution not found')
            return 1
          }
          return hoverThreshold / res
        }

        const overlayLayer = new VectorLayer({
          source: new Vector()
        })
        mapContainer.addLayer(overlayLayer)
        const overlaySource = overlayLayer.getSource()
        if (!overlayLayer || !overlaySource) {
          console.error('Overlay source not created')
          return
        }

        // A function to temporarily add a feature to the overlay layer
        const addFeatureToOverlay = (feature: Feature) => {
          overlaySource.addFeature(feature)
          setTimeout(() => {
            overlaySource.removeFeature(feature)
          }, 500)
        }

        // Define a circle style for the hover interaction
        const hoverCircleStyle = new Style({
          zIndex: 123,
          image: new CircleStyle({
            radius: pixelHoverThreshold(),
            fill: new Fill({ color: 'rgba(255, 110, 110, 0.01)' }),
            stroke: new Stroke({
              color: 'rgba(255, 110, 110, 0.5)',
              width: 1
            })
          })
        })

        const displayFeatureInfo = function (pixel: number[], target: any) {
          if (!siteInfoBox) {
            console.error('Site info box not initialized')
            return
          }
          const feature = target.closest('.ol-control')
            ? undefined
            : mapContainer.forEachFeatureAtPixel(pixel, function (feature) {
                return feature;
              });
          if (feature) {
            console.log('Feature:', feature)

            // Get the position of the map in the window
            const mapPosition = mapContainer.getViewport().getBoundingClientRect();


            siteInfoBox.style.left = (pixel[0] + mapPosition.left) + 'px';
            siteInfoBox.style.top = (pixel[1] + mapPosition.top) + 'px';
            siteInfoBox.style.visibility = 'visible';
            // list all properties of the feature
            console.log('Feature properties:', feature.getProperties())
            console.log('Feature name:', feature.get('name'))
            siteInfoBox.innerText = feature.get('name');
          } else {
            siteInfoBox.style.visibility = 'hidden';
          }
        };
        // Define a variable to hold the map interaction for pointermove events
        // Listen for pointermove events on the map
        mapContainer.on('pointermove', (event) => {
          if (!mapContainerView) {
            console.error('Map view not initialized')
            return
          }
          if (!siteInfoBox)
            return

          if (event.dragging) {
            siteInfoBox.style.visibility = 'hidden';
            return;
          }
          displayFeatureInfo(event.pixel, event.originalEvent.target);
          // Get the coordinates of the pointer event
          // const coords = event.coordinate
          // modifySiteInfoBox('-')
          // Iterate over the spriteCoordinates to check if the pointer is over any of them
          // sitesStatic.forEach(() => {
          //   const pixel = mapContainer.getPixelFromCoordinate(coords)
          //   const feature = vectorSource.getClosestFeatureToCoordinate(coords)
          //   if (feature && pixel) {
          //     const geom = feature.getGeometry()
          //     if (!geom) {
          //       console.error('Geometry not found')
          //       return
          //     }
          //     // Calculate the distance between the pointer and the feature's center
          //     const distance = Math.sqrt(
          //       Math.pow(coords[0] - geom.getCoordinates()[0], 2) +
          //         Math.pow(coords[1] - geom.getCoordinates()[1], 2)
          //     )
          //     // Check if the pointer is within the threshold of the feature
          //     if (distance <= hoverThreshold) {
          //       // console.log('Hovered over sprite:', feature);
          //       modifySiteInfoBox(feature?.get('name'))
          //       // Draw a circle around the feature in the mapInstance
          //       const circle = new Feature({
          //         geometry: new Point(geom.getCoordinates())
          //       })
          //       circle.setStyle(hoverCircleStyle)
          //       addFeatureToOverlay(circle)
          //       return
          //     }
          //   }
          // })
        })

        // Define a click interaction for the map
        mapContainer.on('click', (event) => {
          const target = event.originalEvent.target
          const pixel = event.pixel
          const feature = target.closest('.ol-control')
            ? undefined
            : mapContainer.forEachFeatureAtPixel(pixel, function (feature) {
                return feature;
              });
          if (feature) {
            console.log('Feature:', feature)
            console.log('Feature name:', feature.get('name'))
            // redirect to site page
            // window.location.href = '/site/' + feature?.get('name')
            router.push(`/site/${feature?.get('name')}`)
          } else {
            console.log('No feature found')
          }


          // // Get the coordinates of the pointer event
          // const coords = event.coordinate
          // // Iterate over the spriteCoordinates to check if the pointer is over any of them
          // sitesStatic.forEach(() => {
          //   const pixel = mapContainer.getPixelFromCoordinate(coords)
          //   const feature = vectorSource.getClosestFeatureToCoordinate(coords)
          //   const geom = feature.getGeometry()
          //   if (!geom) {
          //     console.error('Geometry not found')
          //     return
          //   }

          //   if (feature && pixel) {
          //     // Calculate the distance between the pointer and the feature's center
          //     const distance = Math.sqrt(
          //       Math.pow(coords[0] - geom.getCoordinates()[0], 2) +
          //         Math.pow(coords[1] - geom.getCoordinates()[1], 2)
          //     )
          //     // Check if the pointer is within the threshold of the feature
          //     if (distance <= hoverThreshold) {
          //       // console.log('Clicked on sprite:', feature);
          //       // redirect to site page
          //       window.location.href = '/site/' + feature?.get('name')
          //       return
          //     }
          //   }
          // })
        })

        // modifySiteInfoBox('-')

        // get the extent of the vector source
        const extent: Extent = vectorSource.getExtent()
        console.log('Extent:', extent)
        const padding = 100000
        const paddedExtent = [
          extent[0] - padding,
          extent[1] - padding,
          extent[2] + padding,
          extent[3] + padding
        ]
        mapContainer.getView().fit(paddedExtent)
      } // end of onMounted
    ) // end of onMounted

    return { sites }
  } // end of setup
})
</script>

<template>
  <!-- Two column divs flex -->
  <div class="flex">
    <div class="w-1over3">
      <SiteListVue :sites="sites" />
    </div>
    <div class="w-2over3">
      <!-- <div id="site-info">None</div> -->
      <MapComponent />
    </div>
  </div>
</template>
